import React, { useContext, useEffect, useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { saveEnrollment } from '../../fetch/enrollment'
import { FormError } from '../FormError'
import { Button } from '../styles/Button.styled'
import {
    EnrollmentFormCol,
    EnrollmentFormRow,
    EnrollmentStepFooter,
    EnrollmentStepWrapper,
} from '../styles/Enrollment.styled'
import { RadioBox } from './RadioBox'
// import { toast } from 'react-toastify'
import moment, { Moment } from 'moment'
import Datetime from 'react-datetime'
import { Address } from '../../types'
import { EnrollmentContext } from './enrollment'
import { ValidateAddress } from './validate_address'

interface Props {
    show: boolean;
    handleContinue: Function;
    product: string;
    // handleClearSelectedProduct: Function;
}

interface ServiceTypeOption {
    label: string
    value: string
    desc: string
}

export const EnrollmentStepService: React.FC<Props> = ({
    show,
    product,
    handleContinue,
    // handleClearSelectedProduct
}) => {
    const {
        serviceAddress, holidays, handleSetErrorModalContent, getHolidays
        // changeServiceAddress, changeUtility
    } = useContext<any>(EnrollmentContext);

    const { t } = useTranslation('enrollment')
    const serviceTypeOptions = [
        {
            id: 'service-moving',
            label: t('Moving/NewService'),
            value: '1',
            desc: t('I am moving and establishing service under my name at this address.'),
        },
        {
            id: 'service-switching-later',
            label: 'Switching',
            value: '2',
            desc: t('I am not moving. I want to switch to Constellation.com on a specific date.'),
        },
        // {
        //     id: 'service-switching-immediately',
        //     label: t('Switching (Immediately)'),
        //     value: '3',
        //     desc: t(
        //         'I am not moving. I want to switch to the new provider as soon as possible (1-3 days)'
        //     ),
        // },
    ]
    const [serviceType, setServiceType] = useState<ServiceTypeOption | undefined>(undefined)
    const [startDate, setStartDate] = useState<undefined | Moment>(undefined)
    const [loading, setLoading] = useState(false)
    const [errorFields, setErrorFields] = useState<any>({});
    const [cookieAddress, setCookieAddress] = useState<Address | undefined>();

    useEffect(() => {
        let _address = localStorage.getItem('selectedAddress');
        if (!_address) return;
        setCookieAddress(JSON.parse(_address));
    }, [])
    useEffect(() => {
        if (!show) return;
        window.digitalData.page.pageInfo.pageName = "Funnel Step 1"
    }, [show])

    const validate = () => {
        let isValid = true
        let newErrorFields: any = {}
        if (!serviceType) {
            newErrorFields['serviceType'] = t('This field is required')
            isValid = false
        }
        if (
            !startDate ||
            !(
                moment(startDate, 'MM/DD/YYYY', true).isValid() ||
                moment(startDate, 'M/DD/YYYY', true).isValid() ||
                moment(startDate, 'MM/D/YYYY', true).isValid() ||
                moment(startDate, 'M/D/YYYY', true).isValid()
            )
        ) {
            newErrorFields['startDate'] = t('Invalid Date')
            isValid = false
        }


        if (holidays && startDate) {
            if (startDate.isBefore(moment(holidays.start, 'YYYY-MM-DD')) || startDate.isAfter(moment(holidays.end, 'YYYY-MM-DD'))) {
                newErrorFields['startDate'] = t('Invalid Date')
                isValid = false
            }

            const blackoutDate = (holidays?.blackout_dates)?.filter((val: string) => val.indexOf(moment(startDate).format('YYYY-MM-DD')) >= 0);
            if (blackoutDate.length > 0) {
                newErrorFields['startDate'] = t('Invalid Date')
                isValid = false
            }
        }

        setErrorFields(newErrorFields)
        return isValid
    }


    const handleSave = async () => {
        if (loading || !validate()) return;
        setLoading(true);

        let serviceTypeVal = 'MoveIn',
            requestedDate = moment().add(1, 'days').format('MM/DD/YYYY')
        if (serviceType && parseInt(serviceType.value) > 1) {
            serviceTypeVal = 'Switching'
        }
        if (serviceType && parseInt(serviceType.value) < 3) {
            requestedDate = moment(startDate).format('MM/DD/YYYY')
        }
        const { esiid, street, zipcode, city, state } = serviceAddress[0];
        const saveFields = {
            esiid: esiid,
            service_address: street,
            service_zipcode: zipcode,
            service_city: city,
            service_state: state,
            service_type: serviceTypeVal,
            requested_date: requestedDate,
            product: product
        }
        saveEnrollment(null, saveFields, null).then((res) => {
            setLoading(false)

            if (res && parseInt(res.status) === 1 && res.response) {
                const { enrollment_id } = res.response
                const { sign } = res.response
                if (enrollment_id) {
                    handleContinue(enrollment_id, sign)
                } else {
                    handleSetErrorModalContent({
                        title: 'Enrollment Id does not exist'
                    });
                    // toast.error('Enrollment Id does not exist')
                }
            } else {
                handleSetErrorModalContent({
                    title: res.message
                });
                // toast.error(res.message)
            }
        })
    }



    if (!show) return null
    return (
        <EnrollmentStepWrapper>
            <h6 className="mt-2">Service Address *</h6>
            {serviceAddress.length > 0 && cookieAddress && <h5 className="mt-2">{serviceAddress[0]?.label}</h5>}
            {!cookieAddress && <ValidateAddress />}

            {
                (serviceAddress && serviceAddress[0]) &&
                <>
                    <EnrollmentFormRow>
                        <EnrollmentFormCol full>
                            <Form.Group className={errorFields['serviceType'] ? 'error' : ''}>
                                <RadioBox
                                    title={`${t('Why do you need this service?')} *`}
                                    options={serviceTypeOptions}
                                    select={serviceType}
                                    handleSelect={(val: any) => {
                                        setServiceType(val)
                                        getHolidays(val);
                                    }}
                                />
                                <FormError message={errorFields['serviceType']} />
                            </Form.Group>
                        </EnrollmentFormCol>
                    </EnrollmentFormRow>
                    {serviceType && serviceType.value !== '3' && (
                        <>
                            <EnrollmentFormRow>
                                <EnrollmentFormCol>
                                    <Form.Group className={errorFields['startDate'] ? 'error' : ''}>
                                        <Form.Label>{t('Select Date')} *</Form.Label>
                                        <Datetime
                                            value={startDate}
                                            onChange={(date: any) => setStartDate(date)}
                                            dateFormat="MM/DD/YYYY"
                                            timeFormat={false}
                                            closeOnSelect={true}
                                            inputProps={{
                                                placeholder: t('MM/DD/YYYY'),
                                                id: 'select-start-date',
                                                readOnly: true
                                            }}
                                            isValidDate={(currentDate) => {
                                                if (holidays) {
                                                    if (currentDate.isBefore(moment().format('YYYY-MM-DD')) || currentDate.isAfter(moment(holidays.end_date, 'YYYY-MM-DD'))) return false;
                                                    const blackoutDate = (holidays?.blackout_dates)?.filter((val: string) => val.indexOf(moment(currentDate).format('YYYY-MM-DD')) >= 0);
                                                    if (blackoutDate?.length > 0) return false;
                                                    if (!holidays?.rep_service_type?.AllowedDates) {
                                                        return true;
                                                    }
                                                    const allowedDates = (holidays?.rep_service_type?.AllowedDates)?.filter((val: string) => val.indexOf(moment(currentDate).format('YYYY-MM-DD')) >= 0) || [];
                                                    if (allowedDates?.length > 0) return true;
                                                    return false;
                                                }
                                                return true;
                                            }}
                                        />
                                    </Form.Group>
                                    <FormError message={errorFields['startDate']} />
                                </EnrollmentFormCol>
                            </EnrollmentFormRow>
                            <p style={{ marginTop: -20, fontSize: 14, color: '#666' }}>It may take 24 - 48 hours from your service request date for services to be connected.</p>
                        </>
                    )}
                    <EnrollmentStepFooter>
                        <div />
                        <Button onClick={() => handleSave()} data-test-id="cta">
                            <span>{t('Continue')}</span>
                            {loading && (
                                <Spinner animation="border" variant="light" size="sm" className="ms-2" />
                            )}
                        </Button>
                    </EnrollmentStepFooter>
                </>
            }
        </EnrollmentStepWrapper>
    )
}
